const __WEBPACK_NAMESPACE_OBJECT__ = require("@mui/x-date-pickers/DatePicker");